import React, {useState} from 'react';
import styles from './UnitLease.module.css';

const API_BASE_URL = import.meta.env.VITE_API_URL;

const UnitLease = ({ unit }) => {
	const [moveInDate, setMoveInDate] = useState('');
	const [leaseTerm, setLeaseTerm] = useState('12');

	const userID = localStorage.getItem('tenantUserId');
	
	const handleSubmit = async () => {
	  const leaseEndDate = calculateLeaseEndDate(moveInDate, leaseTerm); // logic to clearly determine lease end

		const response = await fetch(`${API_BASE_URL}/users/${userID}/applications/individual/${unit.OfferID}`, {
		  method: 'POST',
		  headers: {'Content-Type': 'application/json'},
		  body: JSON.stringify({
			RentAmount: unit.RentAmount,
			LeaseStartDate: moveInDate,
			LeaseEndDate: leaseEndDate,
			SecurityDeposit: unit.SecurityDeposit || unit.RentAmount
		  })
		});

	  if(response.ok){
		alert("Application submitted successfully!");
	  } else {
		alert("Error submitting application.");
	  }
	};
	
	// Calculates lease end date based on start date and lease term
	const calculateLeaseEndDate = (startDate, leaseTerm) => {
	  if (!startDate || isNaN(parseInt(leaseTerm))) {
		throw new Error("Invalid start date or lease term.");
	  }
	  const date = new Date(startDate);
	  date.setMonth(date.getMonth() + parseInt(leaseTerm));
	  return date.toISOString().split('T')[0];
	};


  return (
    <div className={styles.leaseContainer}>
      <h2 className={styles.title}>Lease Information</h2>

      <div className={styles.detailsHeader}>
        <div className={styles.leaseDetails}>
          <h3>Unit Lease Details</h3>
          <p><strong>RENT:</strong> ${unit.RentAmount}/Month</p>
          <p><strong>Deposit:</strong> ${unit.SecurityDeposit || unit.RentAmount}</p>
          <p><strong>Fees:</strong> ${unit.Fees || 250}</p>
          <p><strong>Due At Signing:</strong> ${unit.TotalDue || (unit.RentAmount * 2 + (unit.Fees || 250))}</p>
        </div>

        <div className={styles.leaseActions}>
          <button className={styles.actionBtn}>Full Details</button>
          <button className={styles.actionBtn}>Payment Calendar</button>
          <button className={styles.actionBtn}>Lease Document</button>
        </div>
      </div>

      <div className={styles.statsContainer}>
        <div className={styles.statItem}>
          <span className={styles.statNumber}>{unit.ApplicationsSubmitted || 3}</span>
          <span className={styles.statText}> Applications Submitted</span>
        </div>
        <div className={styles.statItem}>
          <span className={styles.statNumber}>{unit.ApplicationsApproved || 1}</span>
          <span className={styles.statText}> Applications Approved</span>
        </div>
        <div className={styles.statItem}>
          <span className={styles.statNumber}>{unit.ApprovalOdds || '80%'}</span>
          <span className={styles.statText}> MILO Approval Estimate</span>
        </div>
      </div>

      <div className={styles.applicationForm}>
        <label>
          Move-In Date:
            <input
				type="date"
				value={moveInDate}
				onChange={(e) => setMoveInDate(e.target.value)}
				className={styles.formInput}
			  />
        </label>
        <label>
          Lease Term:
		  <select
			value={leaseTerm}
			onChange={(e) => setLeaseTerm(e.target.value)}
			className={styles.formInput}
		  >
			<option value="12">12 Months</option>
			<option value="6">6 Months</option>
		  </select>
        </label>
      </div>

      <button className={styles.submitBtn} onClick={handleSubmit}>Submit Application</button>
    </div>
  );
};

export default UnitLease;
